const controlledFeatures = {
  FIREBASE_WARNING: 'FIREBASE_WARNING',
  DIRECTORY_DEFAULT_TO_SAME_COUNTRY: 'DIRECTORY_DEFAULT_TO_SAME_COUNTRY',
  DIRECTORY_DEFAULT_TO_SAME_LANGUAGE: 'DIRECTORY_DEFAULT_TO_SAME_LANGUAGE',
  DIRECTORY_DEFAULT_GENDER_ALL: 'DIRECTORY_DEFAULT_GENDER_ALL',
  PRECHECK_SPECIAL_OFFERS: 'PRECHECK_SPECIAL_OFFERS',
  REPEAT_EMAIL_CHECK: 'REPEAT_EMAIL_CHECK',
  DISABLE_REGISTRATION_OVERLAY: 'DISABLE_REGISTRATION_OVERLAY',
  GUEST_CHAT_ACCESS: 'GUEST_CHAT_ACCESS',
};

export default controlledFeatures;
